<template>
  <div id="about-introduce" class="introduce" data-aos="fade-right" :data-aos-duration="1500">
    <div class="introduce-row container">
      <div class="introduce-left">
        <h1>公司简介</h1>
        <span>——</span>
        <p>
          恩莱吉能源科技分别于2011年成立广州市恩莱吉能源科技有限公司和2013年成立深圳市恩莱吉能源科技有限公司。恩莱吉能源科技致力于绿色能源的开发和水电站高端控制设备、设计应用软件的研发，以增效扩容、节能环保为主发展方向，研究绿色水轮机、高油压调桨、机组节能等新技术的运用，并提供水利水电工程投资咨询、勘测设计、工程总承包等专业服务。</p>
      </div>
      <div class="introduce-right">
        <el-image :src="require('@/assets/images/jainjie.jpg')"></el-image>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Introduce"
}
</script>

<style scoped lang="less">
.introduce {

  .introduce-row {
    display: flex;
    justify-content: space-between;
    padding: 80px 0;
    height: 350px;

    .introduce-left {
      padding: 20px 0;
      height: 100%;
      width: 500px;
      box-sizing: border-box;

      h1 {
        font-size: 30px;
      }

      span {
        font-size: 30px;
        color: #1E55AE;
      }

      p {
        font-size: 16px;
        line-height: 35px;
      }
    }

    .introduce-right {
      width: 600px;
      height: 100%;

      div {
        width: 600px;
        height: 350px;
      }
    }
  }
}
</style>